<template lang="pug">
    nav(:class="{collapsible: collapsible, open: open, closed: !open}")
      ul
        li.toggle(@click="open = !open") {{$t('labels.navigation.toggle')}}
        li(v-for="(item, k) in items" :class="{active: item.to && $route.name === item.to.name && item.to.params && $route.params.id === item.to.params.id}")
          router-link(v-if="item.to" :to="item.to") {{item.label}}
          span(v-else @click="item.fn") {{item.label}}
</template>

<script>
export default {
  name: 'NavList',
  props: [
    'items',
    'collapsible'
  ],
  data () {
    return {
      open: true
    }
  },
  watch: {
    $route () {
      this.open = false
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../../css/vars'

.toggle
  display: none

@media screen and (max-width: $media-query-width-tablet-s)
  nav.collapsible.closed
    li
      display none
    .toggle
      display: block
  nav.collapsible.open
    .toggle
      display: none
</style>



// WEBPACK FOOTER //
// src/components/fragments/NavList.vue